module.exports = __webpack_public_path__ + "static/media/truck.05b08387.svg";